import { commonApi } from '@common/utils/baseQuery';
import { IResponseWithPagination } from '@features/types';
import {
  IBaseBet,
  IBaseBetsParams,
  IBaseBetTicket,
  IBaseBetTicketResults,
  ISuperExpressBetsItem,
  ISuperExpressBetsParams,
  ISuperExpressTicket,
} from '@features/user-bets/api/userBetsApi.type';

export const userBetsApi = commonApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchBaseBets: builder.query<IResponseWithPagination<IBaseBet>, IBaseBetsParams>({
      query: ({ processed, freebet, ...params }) => ({
        url: `/bets${freebet ? '?freebet' : processed ? '?processed' : ''}`,
        params,
      }),
      // @ts-expect-error
      providesTags: [ 'UserBets' ],
    }),
    fetchBaseBetTicket: builder.query<IBaseBetTicket, string | number>({
      query: (ticketNo) => `/bets/${ticketNo}/items`,
      // @ts-expect-error
      providesTags: [ 'UserBets' ],
    }),
    fetchBaseBetTicketResults: builder.query<IBaseBetTicketResults[], string | number>({
      query: (ticketNo) => `/bets/${ticketNo}/results`,
    }),
    fetchSuperExpressBets: builder.query<IResponseWithPagination<ISuperExpressBetsItem>, ISuperExpressBetsParams>({
      query: (params) => ({
        url: '/se/bets',
        params,
      }),
    }),
    fetchSuperExpressTicket: builder.query<ISuperExpressTicket, string | number>({
      query: (ticketNo) => `/se/bets/${ticketNo}`,
    }),
  }),
});

export const {
  useFetchBaseBetsQuery,
  useFetchBaseBetTicketQuery,
  useLazyFetchBaseBetTicketResultsQuery,
  useFetchSuperExpressBetsQuery,
  useFetchSuperExpressTicketQuery,
} = userBetsApi;
